<template lang="pug">
    .container
        include Post.pug
</template>

<script>
import _ from 'underscore'
import { mapState } from 'vuex';

export default {
  name: 'Post',
  props: ['slug'],
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      selectVisible: false,
      entry: null,
      related: [],
      title: '',
      description: '',
      meta: [],
    }
  },
  head: {
    title: function () {
      return {
        inner: this.title,
      }
    },
    meta: function () {
      return this.meta
    },
  },
  created() {
    const _this = this

    this.$wagtail.getEntry(this.slug).then((response) => {
      let data = response.data
      _this.meta = []
      _this.entry = _.first(data.results)
      _this.title = _this.entry.title
      _this.meta.push({
        name: 'description',
        content: _this.entry.short_content,
      })

      // Twitter
      _this.meta.push({ name: 'twitter:title', content: _this.entry.title })
      _this.meta.push({
        name: 'twitter:description:title',
        content: _this.entry.short_content,
      })
      if (_this.entry.image)
        _this.meta.push({ name: 'twitter:image', content: _this.entry.image })
      _this.meta.push({ name: 'twitter:card', content: 'summary_large_image' })
      _this.meta.push({ name: 'twitter:site', content: '@Fed_esp_fitness' })

      // Default
      _this.meta.push({ itemprop: 'name', content: _this.entry.title })
      _this.meta.push({
        itemprop: 'description',
        content: _this.entry.short_content,
      })

      // Open graph
      _this.meta.push({ property: 'og:title', content: _this.entry.title })
      _this.meta.push({
        property: 'og:site_name',
        content: 'Federación Española de Fitness',
      })
      _this.meta.push({
        property: 'og:url',
        content: window.location.href.split('?')[0],
      })
      _this.meta.push({ property: 'og:type', content: 'article' })
      _this.meta.push({ property: 'og:locale', content: 'es_ES' })
      if (_this.entry.image)
        _this.meta.push({ property: 'og:image', content: _this.entry.image })

      console.log(_this.entry)

      _this.$emit('updateHead')
    })
  },
  methods: {
    showCategories() {
      this.selectVisible = !this.selectVisible
    },
  },
}
</script>

<style scoped lang="scss">
@import './../../variables';

@import 'Post';
</style>



// WEBPACK FOOTER //
// src/components/blog/Post.vue